import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./globals.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import Wrapper from "./layout/Wrapper";
import { Toaster } from "./components/ui/toaster";
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';

// Suppress ResizeObserver error in development
const observerError = 'ResizeObserver loop completed with undelivered notifications.';
const errorHandler = (e) => {
  if (e.message === observerError) {
    e.stopImmediatePropagation();
  }
};

window.addEventListener('error', errorHandler);


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter basename="/3d">
        {/* <React.StrictMode> */}
        <Wrapper>
            <App />
            <Toaster/>
        </Wrapper>
        {/* </React.StrictMode> */}
    </BrowserRouter>
);
